<template>
    <q-btn flat dense size="sm" class="ma-0">
        {{ label || Translate('Column filters') }}
        <q-icon size="sm">mdi-menu-down</q-icon>
        <q-menu
            v-model="menuopen"
            persistent
            anchor="bottom left"
            self="top left"
            :offset="[0, 8]"
        >
            <q-card @mouseleave="menuopen = false">
                <q-list dense>
                    <template v-for="(item, i) in columngroups" :key="item.divider ? `hdr-${item.flat}-${i}` : `row-${item.text}-${i}`">
                        <q-item-label v-if="item.divider" header>{{ item.flat }}</q-item-label>

                        <q-item
                            v-else
                            tag="label"
                            clickable
                            v-ripple
                            dense
                            class="mediumdense"
                        >
                            <q-item-section side @click.stop>
                                <q-checkbox
                                    dense
                                    color="primary"
                                    :model-value="isSelected(item.text)"
                                    @update:model-value="setSelected(item.text, $event)"
                                />
                            </q-item-section>
                            <q-item-section>
                                <q-item-label>{{ item.flat }}</q-item-label>
                            </q-item-section>
                        </q-item>
                    </template>
                </q-list>
            </q-card>
        </q-menu>
    </q-btn>
</template>

<script>
    import methods from '@/Shared/methods';

    export default {
        data: function () {
            return {
                menuopen: false,
                selection: [],
            }
        },
        props: {
            label: String,
            columngroups: Array,
            columngroups_selection: Array,
        },
        watch: {
            selection: function (newv) {
                this.$emit('change', newv);
            },
            columngroups_selection: {
                handler(newv) {
                    if (Array.isArray(newv)) {
                        this.selection = [...newv];
                    }
                },
                deep: true,
            },
        },
        created() {
            if (Array.isArray(this.columngroups_selection)) {
                this.selection = [...this.columngroups_selection];
            }
        },
        methods: {
            ...methods,
            isSelected(text) {
                return this.selection.includes(text);
            },
            setSelected(text, checked) {
                const idx = this.selection.indexOf(text);
                if (checked && idx < 0) {
                    this.selection = [...this.selection, text];
                } else if (!checked && idx >= 0) {
                    const next = [...this.selection];
                    next.splice(idx, 1);
                    this.selection = next;
                }
            },
        },
    }
</script>

<style scoped>

    .mediumdense {
        max-height: 28px;
        min-height: 28px;
    }

</style>
